'use strict';
const mmWidgets = require('./mm-widgets');
require('./note-widget');
require('./mm-scroll-into-view');
mmWidgets.fn.writerWidget = function (writerModel, splittableModel, noteFormatter) {
	return mmWidgets.each(this, function () {
		const element = this,
			noteTemplate = element.find('[data-mm-role=note-template]').detach(),
			noteForId = function (nodeId) {
				return element.find('[data-mm-role=note][data-mm-node-id="' + nodeId + '"]');
			},
			select = function (nodeId) {
				if (nodeId) {
					writerModel.setActiveNodeId(nodeId);
				}
			},
			activeNote = function () {
				return element.find('[data-mm-role=note].active');
			},
			triggerFocusEvent = function (element, eventType) {
				const evt = document.createEvent('Event');
				evt.initEvent(eventType, true, true);
				element.dispatchEvent(evt);
			},
			placeAt = function (noteElement, newIndex) {
				const floatIndex = parseFloat(newIndex),
					notesBefore = element.find('[data-mm-role=note]').not(noteElement).filter(domElement => parseFloat(domElement.mmData && domElement.mmData.index) < floatIndex),
					viewerElement = noteElement.find('[data-mm-role=viewer]').domElements[0],
					isEditing = document.activeElement === viewerElement;

				if (isEditing) {
					noteElement.data('moving', true);
					triggerFocusEvent(viewerElement, 'blur');
				}

				if (notesBefore.length) {
					noteElement.insertAfter(notesBefore.last());
				} else {
					noteElement.prependTo(element);
				}

				noteElement.data('index', newIndex).data('moving', false);
				if (isEditing) {
					noteElement.find('[data-mm-role=viewer]').focus();
				}
			},
			createNewNote = function (note, shouldEdit) {
				const result = noteTemplate.clone().attr({
					'data-mm-role': 'note',
					'data-mm-node-id': note.nodeId
				});
				placeAt(result, note.index);
				result.noteWidget(writerModel, note, shouldEdit, noteFormatter);
				element.find('[data-mm-role~="no-notes"]').addClass('hidden');
				return result;
			},
			setActive = function (nodeId) {
				const newActive = nodeId && noteForId(nodeId),
					oldActive = element.find('[data-mm-role=note].active');
				splittableModel.showWriter();
				oldActive.removeClass('active');
				if (nodeId && newActive && newActive.length) {
					newActive.addClass('active');
					newActive.mmScrollIntoView();
				}
			},
			editNote = function (note) {
				let noteWidget;
				if (note && note.nodeId) {
					noteWidget = noteForId(note.nodeId);
					splittableModel.showWriter();
					if (noteWidget.length === 0) {
						noteWidget = createNewNote(note, true);
					}
					setActive(note.nodeId);
				}
			},
			noteAdded = function (note) {
				let noteWidget = noteForId(note.nodeId);
				if (noteWidget.length) {
					if (noteWidget.data('index') !== note.index) {
						placeAt(noteWidget, note.index);
					}
					return;
				}
				noteWidget = createNewNote(note, false);
			},
			noteRemoved = function (nodeId) {
				const noteWidget = noteForId(nodeId),
					wasActive = noteWidget && noteWidget.domElements[0] && noteWidget.domElements[0].contains(document.activeElement);
				if (noteWidget) {
					noteWidget.remove();
					if (element.find('[data-mm-role~=note]').length === 0) {
						element.find('[data-mm-role~="no-notes"]').removeClass('hidden');
					} else {
						element.find('[data-mm-role~="no-notes"]').addClass('hidden');
					}
					if (wasActive) {
						element.focus();
					}
				}
			},
			foldInactiveNotes = function () {
				element.find('[data-mm-role~=note]:not(.active)').addClass('folded');
				element.find('[data-mm-role~=note].active').removeClass('folded').mmScrollIntoView();
			},
			noteMoved = function (note) {
				let noteWidget = noteForId(note.nodeId);
				if (!noteWidget.length) {
					noteWidget = createNewNote(note, false);
				} else {
					placeAt(noteWidget, note.index);
				}
			};
		writerModel.addEventListener('activeNodeChanged', setActive);
		writerModel.addEventListener('noteEditRequested', editNote);
		writerModel.addEventListener('noteAdded', noteAdded);
		writerModel.addEventListener('noteRemoved', noteRemoved);
		writerModel.addEventListener('noteMoved', noteMoved);
		writerModel.addEventListener('foldInactiveNotesRequested', foldInactiveNotes);
		element.on('show', function () {
			writerModel.setInputEnabled(true);
		});
		element.on('hide', function () {
			writerModel.setInputEnabled(false);
		});

		element.on('keydown', function (e) {
			const KEY_UP_ARROW = 38,
				KEY_DOWN_ARROW = 40,
				KEY_SPACE = 32,
				KEY_ENTER = 13,
				KEY_ESC = 27,
				mine = function () {
					e.preventDefault();
					e.stopImmediatePropagation();
					e.stopPropagation();
				};
			if (e.target === element.domElements[0]) {
				if (e.which === KEY_UP_ARROW) {
					mine();
					select(activeNote().prev().attr('data-mm-node-id'));
				}
				if (e.which === KEY_DOWN_ARROW) {
					mine();
					select(activeNote().next().attr('data-mm-node-id'));
				}
				if ((e.which === KEY_SPACE || e.which === KEY_ENTER)) {
					mine();
					writerModel.editNoteForNodeId(activeNote().attr('data-mm-node-id'));
				}
			}
			if (e.which === KEY_ESC) { /* perhaps go back to the map? */
				element.focus();
				// handle a case where the active note no longer exists?
			}
		});

	});
};
